export function parseNumber(value: string | number | null | undefined): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const parsed = Number.parseFloat(value ?? '');
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatRuNumber(value: number): string {
  return value.toLocaleString('ru-RU');
}

export function formatMoney(value: string | number | null | undefined, currency = ''): string {
  const amount = parseNumber(value).toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return currency ? `${amount} ${currency}` : amount;
}

export function formatThousandsTick(value: number): string {
  if (Math.abs(value) < 1000) return formatRuNumber(value);
  return `${(value / 1000).toLocaleString('ru-RU', { maximumFractionDigits: 1 })}к`;
}
